<script setup>
import CoursesTable from "./CoursesTable.vue";
</script>

<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">ALL COURSES</h3>
    </div>
    <CoursesTable />
  </div>
</template>
